import { createStore, combineReducers } from 'redux'
import { configure } from 'api'
import { Provider } from 'react-redux'
import { IntlProvider } from 'react-intl'
import { numberOfTrips } from '../actions/search-actions'
import {
  selectedCurrency,
  setCurrency,
  pageLoader,
  itineraryPopupOpen,
  itineraryPopupData,
} from '../actions/main-actions'
import {
  currencyDirective,
  toggleDestinations,
  convertDjangoRenderedPrice,
  hideMobileAppPromotion,
  collapseItems,
} from '../directives'
import ErrorHandler from '../components/ErrorHandler'

// import * as fx from '../libs/money'
import { getLanguage, getTranslations } from 'utils'
import { toast } from 'react-toastify'
import 'babel-polyfill'
import 'whatwg-fetch'
import 'react-toastify/dist/ReactToastify.css'
import '@formatjs/intl-getcanonicallocales/polyfill'
import '@formatjs/intl-locale/polyfill'
import '@formatjs/intl-pluralrules/polyfill'
import '@formatjs/intl-pluralrules/locale-data/en'
import 'finally-polyfill'

import HeroSearch from '../components/homepage/Hero'
import { createRoot } from 'react-dom/client'

if(process.env.SENTRY_KEY) {
  Sentry.init({
    dsn: process.env.SENTRY_KEY,
    ignoreErrors: [
      'AbortError',
      'UnhandledRejection',
      'Unexpected token o in JSON at position 1',
      'Anonymous function(/gtm.js)',
      "undefined is not an object (evaluating 'd.appendChild')",
      'chrome-extension',
      'gtm',
      'Illegal invocation',
      "Can't find variable: setIOSParameters",
      '(app-modern)',
      'd is undefined',
    ],
  })
}

let store = createStore(
  combineReducers({
    pageLoader,
    numberOfTrips,
    selectedCurrency,
    itineraryPopupOpen,
    itineraryPopupData,
  }),
)

let language = getLanguage()
let messages = {}
toast.configure()

window.store = store
configure(store)

// window.fx = fx

if(language !== 'en') {
  getTranslations(language, renderApp)
} else {
  renderApp()
}

function renderApp(translatedStrings) {
  if(translatedStrings) {
    messages = translatedStrings
  }
  renderElement('hero-search', HeroSearch)
  renderElement('search-2', HeroSearch)
  renderElement('search-3', HeroSearch)
  toggleDestinations()
  hideMobileAppPromotion()
  currencyDirective(function(currency) {
    store.dispatch(setCurrency(currency))
  })
  convertDjangoRenderedPrice(renderElement)
  collapseItems(
    '.collapsable',
    '.collapsable-trigger',
    '.collapsable-content',
    true,
  )
}

function renderElement(elem, ComponentToRender, props) {
  let element
  if(typeof elem === 'string') {
    element = document.getElementById(elem)
  } else {
    element = elem
  }

  if(element) {
    const root = createRoot(element)
    root.render(
      <IntlProvider
        locale={language === 'ach' ? 'en' : language}
        messages={messages}
        textComponent='span'
      >
        <Provider store={store}>
          <ErrorHandler>
            <ComponentToRender {...props} />
          </ErrorHandler>
        </Provider>
      </IntlProvider>,
    )
  }
}
